import React from 'react';

const GlobalClientCharts = ({ clients }) => {
  // Función para agregar datos a un objeto y contarlos
  const aggregateData = (key) => {
    return clients.reduce((acc, client) => {
      const value = client[key] || 'Desconocido';
      acc[value] = (acc[value] || 0) + 1;
      return acc;
    }, {});
  };

  // Datos agregados y ordenados
  const getTopData = (data, limit = 5) => {
    return Object.entries(data)
      .filter(([key]) => key !== '') // Filtrar valores vacíos
      .sort(([, a], [, b]) => b - a) // Ordenar por valor descendente
      .slice(0, limit) // Tomar los primeros N elementos
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
  };

  const clientsByCountry = getTopData(aggregateData('country'));
  const clientsBySpecialty = getTopData(aggregateData('specialty'));
  const clientsByCell = getTopData(aggregateData('cell'));

  // Función para renderizar una gráfica de barras simple
  const renderBarChart = (data, title, color) => {
    const dataArray = Object.entries(data).map(([label, value]) => ({ label, value }));

    if (dataArray.length === 0) {
      return (
        <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-[#0061A8]">
          <h4 className="font-medium text-[#0061A8] mb-2">{title}</h4>
          <p className="text-[#63666A] text-sm">No hay datos disponibles</p>
        </div>
      );
    }

    const maxValue = Math.max(...dataArray.map(d => d.value));
    const total = dataArray.reduce((sum, item) => sum + item.value, 0);

    return (
      <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderColor: color }}>
        <div className="flex justify-between items-center mb-4">
          <h4 className="font-medium text-[#0061A8]">{title}</h4>
          <span className="text-sm text-[#63666A]">Total: {total}</span>
        </div>
        <div className="space-y-4">
          {dataArray.map((item, index) => (
            <div key={index} className="relative">
              <div className="flex justify-between text-sm mb-1">
                <span className="font-medium text-[#63666A] truncate pr-2" title={item.label}>
                  {item.label}
                </span>
                <div className="flex items-center space-x-2">
                  <span className="text-[#63666A]">{item.value}</span>
                  <span className="text-xs text-[#63666A]">
                    ({((item.value / total) * 100).toFixed(1)}%)
                  </span>
                </div>
              </div>
              <div className="w-full bg-[#F8F9FA] rounded-full h-3">
                <div
                  className="h-3 rounded-full transition-all duration-500"
                  style={{
                    width: `${(item.value / maxValue) * 100}%`,
                    backgroundColor: color
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="mt-6 space-y-8">
      <h3 className="text-lg font-semibold text-[#0061A8]">Distribución de Clientes</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {renderBarChart(clientsByCountry, 'Top 5 Países', '#0061A8')}
        {renderBarChart(clientsBySpecialty, 'Top 5 Especialidades', '#A8D08D')}
        {renderBarChart(clientsByCell, 'Top 5 Células', '#63666A')}
      </div>
    </div>
  );
};

export default GlobalClientCharts;
